function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { ButtonPrimary } from "../../";
export const ButtonTwitter = ({
  children,
  ...props
}) => {
  return React.createElement(ButtonTwitterWrap, _extends({}, props, {
    iconLeft: React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 32 26"
    }, React.createElement("g", {
      id: "Logos",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, React.createElement("g", {
      id: "Logo/Third-Party/Twitter/Reversed",
      transform: "translate(0.000000, -2.000000)",
      fill: "#FFFFFF"
    }, React.createElement("path", {
      d: "M10.06336,28 C22.13888,28 28.74368,17.9962435 28.74368,9.32103089 C28.74368,9.03689144 28.74368,8.7540319 28.72448,8.47245226 C30.0093841,7.54312537 31.118535,6.39244832 32,5.07429802 C30.8017652,5.6052059 29.5306615,5.95337512 28.22912,6.10718332 C29.5996723,5.28673969 30.6254381,3.99632412 31.11552,2.47608593 C29.8267616,3.24077343 28.416827,3.77968704 26.94656,4.06957069 C24.9114659,1.90575185 21.6777208,1.37614959 19.0586231,2.77773442 C16.4395254,4.17931926 15.086432,7.16352386 15.75808,10.0569777 C10.4792265,9.79235621 5.560929,7.2991909 2.2272,3.19795372 C0.484637128,6.19760203 1.37470449,10.0350394 4.25984,11.9614799 C3.21502874,11.9305158 2.1929976,11.6486874 1.28,11.1397794 C1.28,11.1666574 1.28,11.1948154 1.28,11.2229733 C1.28085521,14.3479863 3.4838419,17.0395577 6.5472,17.6583479 C5.58063308,17.9219321 4.56650315,17.9604628 3.58272,17.7709798 C4.44281335,20.4452476 6.90761544,22.2772572 9.71648,22.3300101 C7.39166085,24.1569908 4.51975617,25.1487857 1.56288,25.1458064 C1.04051657,25.1448037 0.518661204,25.1131784 0,25.0510933 C3.00241402,26.9777079 6.49588915,27.9996377 10.06336,27.9948804",
      id: "Path"
    }))))
  }), children);
};
export const ButtonTwitterWrap = styled(ButtonPrimary)`
  background-color: ${props => props.theme.colors.twitter};
  color: #ffffff;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.twitter};
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  }
`;